import { render, staticRenderFns } from "./cookiesPage.vue?vue&type=template&id=996c5b44&scoped=true&"
import script from "./cookiesPage.vue?vue&type=script&lang=ts&"
export * from "./cookiesPage.vue?vue&type=script&lang=ts&"
import style0 from "./cookiesPage.vue?vue&type=style&index=0&id=996c5b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996c5b44",
  null
  
)

export default component.exports